import { render, staticRenderFns } from "./MessageReadActivity.vue?vue&type=template&id=6c7fd356"
import script from "./MessageReadActivity.vue?vue&type=script&lang=ts"
export * from "./MessageReadActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports